// @flow
import * as React from "react";
import { IsUserAuthenticated } from "./IsUserAuthenticated";

type Props = {
  authOnly?: boolean,
  children: React.Node,
};

export const AuthDeterminedVisibility = ({ authOnly, children }: Props) => {
  if (typeof authOnly === "undefined") return <>{children}</>;

  return authOnly ? (
    <IsUserAuthenticated>{children}</IsUserAuthenticated>
  ) : (
    <IsUserAuthenticated>{({ isUserAuthenticated }) => !isUserAuthenticated && children}</IsUserAuthenticated>
  );
};
